/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavbarWrapper } from './styled';
import { ROUTE_PATH } from 'routes/route.constant';
import ChangePassModal from './components/ChangePassModal';
import { Form } from 'antd';
import ConfirmChangePassModal from './components/ConfirmChangePassModal';
import ChangePassSuccessModal from './components/ChangePassSuccessModal';
import AuthServices from 'services/AuthServices';
import { toast } from 'sonner';
import AdminServices from 'services/AdminServices';
import {
  getAuthLocalStorage,
  isRegexFullWidthCharacter,
  isRegexSpecialCharacter,
  isRegexSpecialCharacterJP,
  isValidPassword,
} from 'helper/utils';
import { NO_INTERNET } from 'components/messageError';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState([]);
  const [isOpenChangePassModal, setIsOpenChangePassModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isChangePassSuccess, setIsChangePassSuccess] = useState(false);
  const [activeBtn, setActiveBtn] = useState(false);
  const [infoUser, setInfoUser] = useState({});
  const user = getAuthLocalStorage() || {};

  const handleGetInfoData = () =>
    isOpenChangePassModal &&
    user?.user?.id &&
    AdminServices.getDetail(user.user.id).then((res) => {
      if (res.isOk) {
        setInfoUser(res.data);
      }
    });

  useEffect(() => {
    handleGetInfoData();
  }, [isOpenChangePassModal]);

  const titlePage = () => {
    switch (location.pathname) {
      case ROUTE_PATH.MEMBER_MANAGEMENT:
        return <div className="text-header">会員管理</div>;
      case ROUTE_PATH.ADMIN_REGISTER:
        return <div className="text-header">管理者登録</div>;

      case ROUTE_PATH.GROUP_REGISTRATION:
        return (
          <div className="text-header">
            <div>問い合わせ</div>
            <div className="sub-title">団体登録申請</div>
          </div>
        );
      case ROUTE_PATH.COURSE_SCHEDULE:
        return <div className="text-header">養成コース</div>;

      case ROUTE_PATH.NEWS_MANAGEMENT:
        return <div className="text-header">NEWS管理</div>;
      case ROUTE_PATH.FESTIVAL_MANAGEMENT:
        return <div className="text-header">フェスタ管理</div>;
      case ROUTE_PATH.FAQ_MANAGEMENT:
        return <div className="text-header">FAQ管理</div>;
      case ROUTE_PATH.STUDIO_MANAGEMENT:
        return <div className="text-header">認定スタジオ管理</div>;
      case ROUTE_PATH.COURSE_MANAGEMENT:
        return <div className="text-header">養成コース登録</div>;
      case ROUTE_PATH.SEMINAL_MANAGEMENT:
        return <div className="text-header">ブラッシュアップセミナー</div>;
      case ROUTE_PATH.NEW_STUDENT_REGISTER:
        return <div className="text-header">新規受講</div>;
      case ROUTE_PATH.STUDENT_RETAKETATION:
        return <div className="text-header">再受講</div>;
      case ROUTE_PATH.CEU_MANAGEMENT:
        return <div className="text-header">CEU管理</div>;
      default:
        break;
    }
  };

  const validatePassword = (value, fieldName) => {
    const errors = [];

    if (!value || value.trim() === '') {
      errors.push(`パスワードを入力してください`);
      return errors;
    }

    if (isRegexFullWidthCharacter().test(value)) {
      errors.push('半角文字で入力してください');
    }

    if (isRegexSpecialCharacterJP().test(value)) {
      errors.push('パスワードに特殊文字は使用できません');
    }

    if (!isRegexSpecialCharacter().test(value)) {
      errors.push('パスワードに特殊文字は使用できません');
    }

    if (!isValidPassword().test(value)) {
      errors.push('パスワードは6～14文字で入力してください');
    }

    return errors;
  };

  const handleConfirmPassword = () => {
    const newErrors = [];

    // Validate old password
    const oldPasswordErrors = validatePassword(
      form.oldPassword,
      '以前のパスワード'
    );
    if (oldPasswordErrors.length > 0) {
      newErrors.push({
        label: 'oldPassword',
        message: oldPasswordErrors[0],
      });
    }

    // Validate new password
    const newPasswordErrors = validatePassword(
      form.newPassword,
      '新しいパスワード'
    );
    if (newPasswordErrors.length > 0) {
      newErrors.push({
        label: 'newPassword',
        message: newPasswordErrors[0],
      });
    }

    // Validate confirm password
    const confirmPasswordErrors = validatePassword(
      form.confirmPassword,
      '新パスワード（確認）'
    );
    if (confirmPasswordErrors.length > 0) {
      newErrors.push({
        label: 'confirmPassword',
        message: confirmPasswordErrors[0],
      });
    } else if (form.confirmPassword !== form.newPassword) {
      newErrors.push({
        label: 'confirmPassword',
        message: 'パスワードが一致しません',
      });
    }

    // Check if old password and new password are the same
    if (
      form.oldPassword &&
      form.newPassword &&
      form.oldPassword === form.newPassword
    ) {
      toast.error('新しいパスワードと以前のパスワードが同じです');
      return;
    }

    setErrors(newErrors);

    if (newErrors?.length === 0) {
      setIsOpenChangePassModal(false);
      setIsConfirm(true);
    }
  };

  const handleChangeDataPass = ({ label, value }) => {
    setForm({ ...form, [label]: value });
    setErrors(errors.filter((error) => error.label !== label));
  };

  const handleSubmit = () => {
    setLoading(true);
    setDisableSubmit(true);
    AuthServices.updatePassByAdmin({
      oldPassword: form.oldPassword,
      password: form.newPassword,
    })
      .then((res) => {
        if (res.isOk) {
          setIsChangePassSuccess(true);
          setForm({
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
          });
        }
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => {
        setLoading(false);
        setDisableSubmit(false);
      });
  };

  return (
    <NavbarWrapper>
      <div className="admin">
        <div className="admin-icon" style={{ cursor: 'pointer' }}>
          <img
            onClick={() => setIsOpenChangePassModal(true)}
            src={`${process.env.PUBLIC_URL}/images/admin.png`}
            alt="Admin"
          />
        </div>
        <div
          className="logout-icon"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            localStorage.clear();
            navigate(ROUTE_PATH.LOGIN);
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/logout.png`}
            alt="Logout"
          />
        </div>
      </div>

      {isOpenChangePassModal && (
        <ChangePassModal
          activeBtn={activeBtn}
          dataPass={form}
          errors={errors}
          infoUser={infoUser}
          onConfirm={handleConfirmPassword}
          setErrors={setErrors}
          handleChangeDataPass={handleChangeDataPass}
          isOpen={isOpenChangePassModal}
          onCancel={() => {
            setIsOpenChangePassModal(false);
            setErrors([]);
            setForm({
              oldPassword: '',
              newPassword: '',
              confirmPassword: '',
            });
          }}
        />
      )}
      {isConfirm && (
        <ConfirmChangePassModal
          isOpen={isConfirm}
          onOk={handleSubmit}
          disableSubmit={disableSubmit}
          loading={loading}
          onClose={() => {
            setIsConfirm(false);
            setIsOpenChangePassModal(false);
            setErrors([]);
            setForm({
              oldPassword: '',
              newPassword: '',
              confirmPassword: '',
            });
          }}
          onCancel={() => {
            setIsConfirm(false);
            setIsOpenChangePassModal(true);
          }}
        />
      )}
      {isChangePassSuccess && (
        <ChangePassSuccessModal
          isOpen={isChangePassSuccess}
          onClose={() => {
            setIsChangePassSuccess(false);
            setIsOpenChangePassModal(false);
            setIsConfirm(false);
            setErrors([]);
            setForm({
              oldPassword: '',
              newPassword: '',
              confirmPassword: '',
            });
          }}
        />
      )}
      {titlePage()}
    </NavbarWrapper>
  );
}

export default Navbar;
